import { render, staticRenderFns } from "./AdminHomepage.vue?vue&type=template&id=8a5ad984&scoped=true&"
import script from "./AdminHomepage.vue?vue&type=script&lang=js&"
export * from "./AdminHomepage.vue?vue&type=script&lang=js&"
import style0 from "./AdminHomepage.vue?vue&type=style&index=0&id=8a5ad984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5ad984",
  null
  
)

export default component.exports